import { render, staticRenderFns } from "./ccBoard.vue?vue&type=template&id=0e475790&"
import script from "./ccBoard.vue?vue&type=script&lang=js&"
export * from "./ccBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports